import { RouterConfig } from '@angular/router';

import { ScenarioActivitiesComponent } from './scenario-activities.component';
import { ScenarioCreateComponent } from './scenario-create.component';
import { ScenarioCreateResultsComponent } from './scenario-create-results.component';
import { ScenarioSelectFacilitiesComponent } from './scenario-select-facilities.component';
import { ScenarioDeleteListComponent } from './scenario-delete-list.component';
import { ScenarioUpdateComponent } from './scenario-update.component';
import { ScenarioModifyFacilitiesComponent } from './scenario-modify-facilities.component';
import { ScenarioReforecastComponent } from './scenario-reforecast.component';
import { ScenarioReforecastCompleteComponent } from './scenario-reforecast-complete.component';
import { AuthGuard } from '../authentication/auth-guard.service';

export const ScenarioActivitiesRoutes: RouterConfig = [
  { path: 'scenario-activities', component: ScenarioActivitiesComponent, canActivate: [AuthGuard] },
  { path: 'scenario-create', component: ScenarioCreateComponent, canActivate: [AuthGuard] },
  { path: 'scenario-create-results', component: ScenarioCreateResultsComponent, canActivate: [AuthGuard]},
  { path: 'scenario-select-facilities', component: ScenarioSelectFacilitiesComponent, canActivate: [AuthGuard]},
  { path: 'scenario-delete', component: ScenarioDeleteListComponent, canActivate: [AuthGuard] },
  { path: 'scenario-update', component: ScenarioUpdateComponent, canActivate: [AuthGuard] },
  { path: 'scenario-modify-facilities', component: ScenarioModifyFacilitiesComponent, canActivate: [AuthGuard] },
  { path: 'scenario-reforecast', component: ScenarioReforecastComponent, canActivate: [AuthGuard] },
  { path: 'scenario-reforecast-complete', component: ScenarioReforecastCompleteComponent, canActivate: [AuthGuard]}
];



/** WEBPACK FOOTER **
 ** ./app/scenario-activities/scenario-activities.routes.ts
 **/